import { actions } from '@app/action/layout';

export default function(state = {}, action) {
  const { type } = action;
  switch (type) {
    case actions.HIDE_UI: {
      return {
        ...state,
        hidden: true,
      };
    }

    case actions.SHOW_UI:
      return {
        ...state,
        hidden: false,
      };
    case actions.SET_WALLPAPER_UI_STYLE:
      return {
        ...state,
        wallpaper: {
          ...state.wallpaper,
          ...action.styles,
        },
      };
    case actions.RESET_WALLPAPER_UI_STYLE:
      return {
        ...state,
        wallpaper: {
          uploadSpinnerTransitionColor:
            state.wallpaper.uploadSpinnerTransitionColor,
        },
      };
  }

  return state;
}
